import React, { Component } from "react";
import { Menu, Dropdown, Label, Icon } from "semantic-ui-react";
import { Link, withRouter } from "react-router-dom";
import { logoutUser } from "../../auth/authActions";
import { connect } from "react-redux";
import {
  getItem,
  deleteDataOnLogOut,
  getHourDifference,
  // isSuperUser,
} from "../../../app/common/util/genericUtils";
import { resetHomeState } from "../../home/homeActions";
import { getIsMobileViewport } from "../../../app/common/util/useIsMobile";

const actions = {
  logoutUser,
  resetHomeState,
};
const mapStateToProps = (state) => ({
  latestNotification: state.notification.latestNotification,
});

const getInitials = (username) => {
  if (!username || typeof username !== "string") return "U";
  const parts = username.trim().split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return username.slice(0, 2).toUpperCase();
};

class NavBar extends Component {
  state = {
    dropdownOpen: false,
    menuOpen: false,
    isMobile: getIsMobileViewport(),
  };

  componentDidMount() {
    this.handleResize = () => {
      this.setState({ isMobile: getIsMobileViewport() });
    };
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleLogOut = () => {
    deleteDataOnLogOut();
    this.props.logoutUser();
    this.props.history.push("/login");
    this.props.resetHomeState();
    this.setState({ dropdownOpen: false });
  };

  handleDropdownOpen = () => {
    this.setState({ dropdownOpen: true, menuOpen: false });
  };

  handleDropdownClose = () => {
    this.setState({ dropdownOpen: false });
  };

  handleMenuOpen = () => {
    this.setState({ menuOpen: true, dropdownOpen: false });
  };

  handleMenuClose = () => {
    this.setState({ menuOpen: false });
  };

  handleMenuNavigate = () => {
    this.setState({ menuOpen: false });
  };

  render() {
    const user = getItem("suprolUser");
    const { latestNotification } = this.props;
    const { dropdownOpen, menuOpen, isMobile } = this.state;
    const hourDiff =
      latestNotification !== null
        ? getHourDifference(latestNotification.created_on)
        : 25;
    const username =
      (user && user.user && user.user.username) || "User";
    const email = (user && user.user && user.user.email) || "";
    const initials = getInitials(username);

    return (
      <Menu inverted fixed="top" id="navbar-style" className="app-navbar">
        {isMobile && (
          <Menu.Item className="navbar-mobile-menu-item">
            <Dropdown
              pointing="top left"
              className="navbar-mobile-menu-dropdown"
              icon={null}
              open={menuOpen}
              onOpen={this.handleMenuOpen}
              onClose={this.handleMenuClose}
              trigger={
                <button
                  type="button"
                  className="navbar-hamburger-btn"
                  aria-label="Open navigation menu"
                  aria-expanded={menuOpen}
                >
                  <Icon name="bars" />
                </button>
              }
            >
              <Dropdown.Menu className="navbar-mobile-menu">
                <Dropdown.Item
                  as={Link}
                  to="/"
                  icon="home"
                  text="Home"
                  onClick={this.handleMenuNavigate}
                />
                <Dropdown.Item
                  as={Link}
                  to="/search"
                  icon="search"
                  text="Search Orders"
                  onClick={this.handleMenuNavigate}
                />
                <Dropdown.Item
                  as={Link}
                  to="/reports"
                  icon="chart bar"
                  text="Reports"
                  onClick={this.handleMenuNavigate}
                />
                {/* {isSuperUser() && (
                  <Dropdown.Item
                    as={Link}
                    to="/whatsapp"
                    icon="whatsapp"
                    text="WhatsApp"
                    onClick={this.handleMenuNavigate}
                  />
                )} */}
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}

        {!isMobile && (
          <div className="navbar-desktop-layout">
            <Link to="/" className="navbar-desktop-brand" aria-label="SUPROL Home">
              <img
                src="/assets/suprol-logo.png?v=2"
                alt="SUPROL"
                className="navbar-logo navbar-logo--desktop"
              />
            </Link>
          </div>
        )}

        {isMobile && (
          <Link
            to="/"
            className="navbar-mobile-brand"
            onClick={this.handleMenuClose}
            aria-label="SUPROL Home"
          >
            <img
              src="/assets/suprol-logo.png?v=2"
              alt="SUPROL"
              className="navbar-logo navbar-logo--mobile"
            />
          </Link>
        )}

        {latestNotification && hourDiff < 25 && (
          <div className="navbar-notification-wrap">
            <marquee behavior="scroll" direction="left">
              <Label basic color="purple" className="navbar-notification-label">
                {latestNotification.text}
              </Label>
            </marquee>
          </div>
        )}

        <div className="navbar-profile-container">
          <Menu.Item className="navbar-profile-item">
            <Dropdown
              pointing="top right"
              className="navbar-user-dropdown"
              icon={null}
              open={isMobile ? dropdownOpen : undefined}
              onOpen={this.handleDropdownOpen}
              onClose={this.handleDropdownClose}
              trigger={
                <button
                  type="button"
                  className="navbar-profile-trigger"
                  aria-label={`Account menu for ${username}`}
                  aria-expanded={dropdownOpen}
                >
                  <span className="navbar-avatar-fallback" aria-hidden="true">
                    {initials}
                  </span>
                  <span className="navbar-profile-meta">
                    <span className="navbar-username">{username}</span>
                    {email ? (
                      <span className="navbar-user-email">{email}</span>
                    ) : null}
                  </span>
                  <Icon name="chevron down" className="navbar-profile-caret" />
                </button>
              }
            >
              <Dropdown.Menu className="navbar-dropdown-menu">
                <div className="navbar-dropdown-header">
                  <span className="navbar-dropdown-header__avatar" aria-hidden="true">
                    {initials}
                  </span>
                  <div className="navbar-dropdown-header__meta">
                    <span className="navbar-dropdown-header__name">{username}</span>
                    {email ? (
                      <span className="navbar-dropdown-header__email">{email}</span>
                    ) : (
                      <span className="navbar-dropdown-header__email">Signed in</span>
                    )}
                  </div>
                </div>
                <Dropdown.Divider />
                <Dropdown.Item
                  className="navbar-logout-item"
                  onClick={this.handleLogOut}
                >
                  <Icon name="sign-out" />
                  <span>Log out</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </div>
      </Menu>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(NavBar)
);
